<template>

  <!-- AD Popup -->
  <van-popup
      class="ad-popup main-color"
      :value="value"
      @input="onShowChange"
      round
      :style="{ width: '80%' }"
      :close-on-click-overlay="false"
  >

    <div class="vertical text-center w-full relative">
      <NotificationItem :notification="advertise" @click="click" :show-status="false" :height="250"/>
      <div class="horizontal items-center justify-center">
        <img src="../../assets/icons/v2/icon_popup_close.png" class="w-9 h-9 mt-6 p-2" @click="onInput(false)"/>
      </div>
      <div v-if="enableCountDown" class="count-down">{{ countDownSeconds }} S</div>
    </div>
  </van-popup>
</template>

<script>
import log from "@/util/log";
import NotificationItem from "@/components/notification/NotificationItem.vue";
import { openExternalUrl } from "@/util/utils";

export default {
  name: "PopupAd",
  components: { NotificationItem },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    advertise: {
      type: Object,
      default: () => {
        return {};
      }
    },
    enableCountDown: {
      type:Boolean,
      default:true
    }
  },
  data() {
    return {
      countDownSeconds: 3,
      intervalId: 0
    };
  },
  watch: {
    value(newVal) {
      console.log(`执行定时器`)
      if (!this.enableCountDown) {
        return false
      }
      if (newVal) {
        this.clearTimer();
        this.startTimer();
      } else {
        this.clearTimer();
      }
    }
  },
  methods: {
    startTimer() {
      this.intervalId = setInterval(() => {
        let second = this.countDownSeconds;
        second--;
        if (second < 1) {
          this.$emit("input", false);
          return;
        }
        this.countDownSeconds = second;
      }, 1000);
    },
    clearTimer() {

      clearInterval(this.intervalId);
    },
    click() {
      const { id, eventName, isExternalEvent, externalEventLink } = this.advertise;
      if (isExternalEvent) {
        openExternalUrl(externalEventLink)
        this.$emit('input',false)
        return;
      }
      this.$router.push({
        name: "NotificationsDetail",
        query: {
          newsId: id,
          title: eventName
        }
      });
      this.$emit("input", false);
    },
    onInput(e) {
      this.$emit("input", e);
    },
    onDeviceNameChange() {
      const value = this.content;
      if (value.length >= this.maxLength) this.content = value.slice(0, this.maxLength);
      this.$emit("onDeviceNameChange", this.content);
    },
    onShowChange(e) {
      log(`单行编辑框弹框 ${e}`);
      this.$emit("input", e);
    },
    onCancelClick() {
      log(`单行编辑框弹框 取消 `);
      this.$emit("input", false);
      this.$emit("onCancel");
    },
    onConfirmClick() {
      log(`单行编辑框弹框 确认 ${this.content}`);
      this.$emit("onConfirm", this.content);
    }
  },
  mounted() {
    if (!this.enableCountDown) {
      return false
    }
    this.clearTimer()
    this.startTimer();
  }
};
</script>


<style scoped lang="less">

.ad-popup {
  padding: 16px;
  text-align: center;

  & > * + * {
    margin-top: 16px;
  }

  .single-edit-title {
    font-size: 21px;
    text-align: center;
    width: 100%;
  }

  .single-edit-content {
    padding: 15px 23px 20px 23px;
    font-size: 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }


  .single-edit-msg {

  }

  .input {
    width: 100%;
    padding: 0 16px;
  }

}

.van-popup {
  background: transparent;
}

.count-down {
  position: absolute;
  right: 8px;
  top: 8px;
  font-size: 12px;
  background: rgba(51, 51, 51, 0.3);
  color: white;
  padding: 4px 16px;
  border-radius: 4px;;
}
</style>